<template>
<div style="height: 100vh; overflow-y: auto">
  <todo ref="todo" v-if="active === 'todo'"></todo>
  <done ref="done" v-if="active === 'done'"></done>
  <sponsor ref="sponsor" v-if="active === 'sponsor'"></sponsor>
  <van-tabbar v-model="active" :fixed="true" :placeholder="false" :safe-area-inset-bottom="true" inactive-color="#333" @change="change">
    <van-tabbar-item icon="underway-o" name="todo">我的待办</van-tabbar-item>
    <van-tabbar-item icon="passed" name="done">我的已办</van-tabbar-item>
    <van-tabbar-item icon="guide-o" name="sponsor">我发起的</van-tabbar-item>
  </van-tabbar>
</div>
</template>

<script>
import todo from "./todo";
import done from './done'
import sponsor from "./sponsor";
import DingtalkService from '@/api/dingtalk/DingtalkService.js'
import Vue from "vue";

export default {
  name: "flowableIndex",
  data(){
    return {
      active: 'todo',
      corpId: 'ding8dc103866cff029924f2f5cc6abecb85',
      loginTimer: null,
      loginSuccess: false
    }
  },
  created() {
    this.active = localStorage.getItem('tabbarName') || 'todo'
    this.checkLoginAndExecute()
  },
  beforeDestroy() {
    if (this.loginTimer) {
      clearTimeout(this.loginTimer)
    }
  },
  components: {
    todo,
    done,
    sponsor
  },
  methods: {
    change(value){
      localStorage.setItem('tabbarName', value)
    },
    checkLoginAndExecute() {
      const token = Vue.cookie.get('token')
      const userId = Vue.cookie.get('userId')

      if (!token || !userId) {
        this.reloadDingtalkEnvironment()
      }
    },
    reloadDingtalkEnvironment() {
      const reloadKey = 'dingtalk_login_reloaded_' + this.corpId
      const hasReloaded = localStorage.getItem(reloadKey)

      if (hasReloaded) {
        localStorage.removeItem(reloadKey)
        this.executeLogin()
        return
      }

      localStorage.setItem(reloadKey, 'true')
      window.location.reload()
    },
    executeLogin() {
     Vue.cookie.delete('token')
      Vue.cookie.delete('pm-token')
      Vue.cookie.delete('date');
      Vue.cookie.delete('name');
      Vue.cookie.delete('userId');
      Vue.cookie.delete('sjplsp')
      Vue.cookie.delete('searchValue')
      Vue.cookie.delete('searchTitle')
      Vue.cookie.delete('searchTitleId')
      Vue.cookie.delete('todoSearchValue')
      Vue.cookie.delete('doneSearchValue')
      Vue.cookie.delete('sponsorSearchValue')
      localStorage.removeItem('current')
      localStorage.removeItem('scrollTopPosition')
      localStorage.removeItem('size')
      localStorage.removeItem('SponsorCurrent')
      localStorage.removeItem('scrollSponsorPosition')
      localStorage.removeItem('SponsorSize')
      localStorage.removeItem('DoneCurrent')
      localStorage.removeItem('scrollDonePosition')
      localStorage.removeItem('DoneSize')
      localStorage.removeItem('tabbarName')
      localStorage.removeItem('category')
      localStorage.removeItem('businessTable')
      localStorage.removeItem('businessName')

      let loginSuccess = false

      const loginTimeout = setTimeout(() => {
        if (!loginSuccess) {
          this.$toast.fail('登录超时，请手动刷新页面重试')
        }
      }, 10000)

      this.loginTimer = loginTimeout

      const doLogin = () => {
        dd.runtime.permission.requestAuthCode({
          corpId: this.corpId,
          onSuccess: (result) => {
            new DingtalkService().dingtalkLogin(result.code, this.corpId).then(({data}) => {
              if(data.code === 200) {
                Vue.cookie.set('token', data.token)
                Vue.cookie.set('date', data.date)
                Vue.cookie.set('name', data.name)
                Vue.cookie.set('userId', data.userId)
                Vue.cookie.set('sjplsp', data.sjplsp)

                loginSuccess = true
                this.loginSuccess = true
                switch (this.active) {
                  case 'todo':
                    this.$refs.todo.onLoad()
                    break
                  case 'done':
                    this.$refs.done.onLoad()
                    break
                  case 'sponsor':
                    this.$refs.sponsor.onLoad()
                    break
                }
                clearTimeout(loginTimeout)
              } else {
                this.$toast.fail(data.message)
              }
            })
          },
          onFail: (err) => {
            this.$message.error('err:' + JSON.stringify(err));
          }
        });

        // 物料系统登录，失败不影响主系统登录
        dd.runtime.permission.requestAuthCode({
          corpId: this.corpId,
          onSuccess: (result) => {
            new DingtalkService().materDingtalkLogin(result.code).then(({data}) => {
              Vue.cookie.set('pm-token', data.token)
              Vue.cookie.set('mater-userId', data.userId)
            })
          },
          onFail: (err) => {
            this.$message.error('err:' + JSON.stringify(err));
          }
        });
      }

      if (dd.version) {
        doLogin()
      } else {
        dd.ready(() => {
          doLogin()
        })
        dd.error((err) => {
          clearTimeout(loginTimeout)
          this.$toast.fail('钉钉环境初始化失败，请手动刷新页面重试')
        })
      }
    }
  }
}
</script>

<style scoped>
.bottom {
  display: flex;
  width: 100vw;
  height: 50px;
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
}

.bottom-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>

<style>
.van-tabbar-item__text {
  font-size: 14px;
}

/*.van-tabbar-item--active {*/
/*  color: #1989fa!important;*/
/*}*/
</style>
